// import { firebaseConfig, apiConfig, toyyibPayConfig } from './sjpay-config-dev';
// import { firebaseConfig, apiConfig, toyyibPayConfig } from './sjpay-config-live';
import { firebaseConfig, apiConfig, toyyibPayConfig } from './sjpay-config-staging';

export const Config = {
    firebaseConfig: firebaseConfig,
    apiConfig: apiConfig,
    toyyibPayConfig: toyyibPayConfig
};
